import React, { useEffect, useState, useCallback, useMemo } from "react";
import { useAuth } from "react-oidc-context";
import "./BranchHome.css";
import { Helmet } from "react-helmet";
import {
  FaSyncAlt,
  FaArrowUp,
  FaArrowDown,
  FaSearch,
  FaHistory,
  FaCalculator,
  FaEdit,
  FaSave,
  FaPercentage,
  FaPlus,
  FaTrash,
  FaEye,
  FaEyeSlash,
} from "react-icons/fa";
import Message from "./Message";
import InstallPWA from "./InstallPWA";
import { PiPhoneCallFill } from "react-icons/pi";
import { BiSolidMessageDetail } from "react-icons/bi";
import BranchDetailLedger from "./BranchDetailLedger";
import BranchHistoryLedger from "./BranchHistoryLedger";
import "./BranchHistoryLedger.css";
import requestForToken from "../firebase-config";
import BranchRejected from "./BranchRejected";
import { Link } from "react-router-dom";
const API_URL = `https://${process.env.REACT_APP_API_KEY_TRANS}.execute-api.ap-south-1.amazonaws.com/default/branchTransaction`;
const VIEW_REQUEST_API = `https://${process.env.REACT_APP_API_KEY_VIEW_REQUEST}.execute-api.ap-south-1.amazonaws.com/default/branchViewRequest`;
const BRANCH_LIST_URL = `https://${process.env.REACT_APP_API_KEY_AUTH_BRANCH}.execute-api.ap-south-1.amazonaws.com/default/createBranch`;
const R_URI = process.env.REACT_APP_AUTH_DOMAIN;
export const PARTY_API_URL = `https://${process.env.REACT_APP_THIRD_PARTY_API_URL}.execute-api.ap-south-1.amazonaws.com/default/thirdPartyUpdate`;
const PATCH_API_URL = `https://${process.env.REACT_APP_STATUS_UPDATE_API_URL}.execute-api.ap-south-1.amazonaws.com/default/StatusUpdateFun`;
export default function BranchHome() {
  const auth = useAuth();
  const userEmail = auth.user?.profile?.email || "Unknown";
  // const [waitingTransactions, setWaitingTransactions] = useState([]);
  // const [waitingTransactionsIN, setWaitingTransactionsIN] = useState(0);
  // const [waitingTransactionsOUT, setWaitingTransactionsOUT] = useState(0);
  const [valuesHidden, setValuesHidden] = useState(false);
  const [viewDay, setViewDay] = useState(0); // 0 = Today, 1 = Yesterday
  const [branchSummary, setBranchSummary] = useState({});
  const [branchId, setBranchId] = useState(null);
  const [allBranches, setAllBranches] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false); // refresh button only
  const [actionLoading, setActionLoading] = useState(false); // post/edit/split buttons only
  const [party, setParty] = useState([]);
  const [branchFilter, setBranchFilter] = useState("");
  const [typeFilter, setTypeFilter] = useState("ALL");
  const [selectedType, setSelectedType] = useState("IN");
  const [isToBranch, setIsToBranch] = useState(true); // Toggle for To Branch vs 3rd Party
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [editingId, setEditingId] = useState(null);
  const [editValues, setEditValues] = useState({ commission: 0, remarks: "" });
  const [splitTx, setSplitTx] = useState(null);
  const [keepAmount, setKeepAmount] = useState(0);
  const [otherSplits, setOtherSplits] = useState([
    { branch: "", amount: 0, remarks: "", receiverName: "", receiverCell: "" },
  ]);
  const [branchSearch, setBranchSearch] = useState("");
  const [partySearch, setPartySearch] = useState("");
  // History request state
  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [showHistoryLedger, setShowHistoryLedger] = useState(false);
  const [historyRequest, setHistoryRequest] = useState(null); // latest request for this branch
  const [historySelectedDates, setHistorySelectedDates] = useState([]);
  const [historySubmitting, setHistorySubmitting] = useState(false);

  const getISTDateString = useCallback((offsetDays = 0) => {
    const IST_OFFSET = 5.5 * 60 * 60 * 1000;
    return new Date(Date.now() - offsetDays * 24 * 60 * 60 * 1000 + IST_OFFSET)
      .toISOString()
      .split("T")[0];
  }, []);

  const currentFormattedDate = useMemo(() => {
    return getISTDateString(viewDay);
  }, [viewDay, getISTDateString]);
  // Summary Date Filter
  useEffect(() => {
    if (auth.isAuthenticated) {
      requestForToken(branchId);
    }
  }, [auth.isAuthenticated, branchId]);
  const handleSignOut = () => {
    auth.removeUser();
    localStorage.clear();
    const clientId = "1a39ivjo9rt6lqngrp085egiqp";
    const domain = "ap-south-1568k9cbda.auth.ap-south-1.amazoncognito.com";
    const cognitoLogoutUrl = `https://${domain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(
      R_URI,
    )}`;
    window.location.href = cognitoLogoutUrl;
  };
  // --- BALANCE SYNC HELPER ---
  const checkDate = useCallback((timestamp, offset = 0) => {
    const IST_OFFSET = 5.5 * 60 * 60 * 1000;

    const toISTDateString = (ms) => {
      return new Date(ms + IST_OFFSET).toISOString().split("T")[0];
    };

    const txDate = toISTDateString(new Date(timestamp).getTime());

    const target = new Date();
    target.setDate(target.getDate() - offset);
    const targetDate = toISTDateString(target.getTime());

    return txDate === targetDate;
  }, []);

  const fetchParty = useCallback(async () => {
    try {
      const res = await fetch(PARTY_API_URL, {
        method: "GET",
        headers: {
          // Use the access token from the auth context
          Authorization: `Bearer ${auth.user.access_token}`,
        },
      });
      const data = await res.json();
      setParty(data.branches || []);
    } catch (error) {
      console.error("Error fetching branches:", error);
    } finally {
      setLoading(false);
    }
    // Dependency array for useCallback: auth.user.access_token is the only external dependency used inside fetchBranches
  }, [auth.user?.access_token]);

  useEffect(() => {
    fetchParty();
  }, [fetchParty]);

  const resolveBranch = useCallback(async () => {
    try {
      const res = await fetch(BRANCH_LIST_URL);
      const data = await res.json();
      const branchesArr = data.branches || [];
      setAllBranches(branchesArr.map((b) => b.id));
      const match = branchesArr.find(
        (b) => b.email?.toLowerCase() === userEmail.toLowerCase(),
      );
      if (match) setBranchId(match.id);
    } catch (err) {
      console.error(err);
    }
  }, [userEmail]);

  const fetchTransactions = useCallback(
    async (myId) => {
      if (!myId) return;
      setLoading(true);
      try {
        const now = new Date();
        const startOfYesterday = new Date(
          new Date().toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" }),
        );
        startOfYesterday.setDate(startOfYesterday.getDate() - 1);
        startOfYesterday.setHours(0, 0, 0, 0);

        const res = await fetch(API_URL, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            action: "fetchTransactions",
            branchId: myId,
            from: startOfYesterday.toISOString(),
            to: now.toISOString(),
          }),
        });

        const data = await res.json();
        const sorted = (data.transactions || []).sort(
          (a, b) => new Date(b.timestamp) - new Date(a.timestamp),
        );
        setTransactions(sorted);
      } catch (err) {
        console.error(err);
        window.alert("Failed to get transactions. Please click Refresh.");
      } finally {
        setLoading(false);
      }
    },
    [],
  );

  useEffect(() => {
    resolveBranch();
  }, [resolveBranch]);

  // --- History Request Fetch ---
  const fetchHistoryRequest = useCallback(async (bId) => {
    if (!bId) return;
    try {
      const res = await fetch(`${VIEW_REQUEST_API}?branchId=${bId}`);
      const data = await res.json();
      const requests = data.requests || [];
      // Get the most recent one
      const latest = requests.sort((a, b) => new Date(b.requestedAt) - new Date(a.requestedAt))[0] || null;
      setHistoryRequest(latest);
    } catch (err) {
      console.error("History request fetch error:", err);
    }
  }, []);

  useEffect(() => {
    if (branchId) fetchHistoryRequest(branchId);
  }, [branchId, fetchHistoryRequest]);

  const past7Days = useMemo(() => {
    return Array.from({ length: 7 }, (_, i) => {
      const dateStr = getISTDateString(i + 1);
      const d = new Date(dateStr);
      return {
        value: dateStr,
        label: d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", weekday: "short" }),
      };
    });
  }, [getISTDateString]);

  const handleHistorySubmit = async () => {
    if (historySelectedDates.length === 0) return alert("Select at least one date");
    setHistorySubmitting(true);
    try {
      const res = await fetch(VIEW_REQUEST_API, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ branchId, requestedDates: historySelectedDates }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "Request failed");
      await fetchHistoryRequest(branchId);
      setHistorySelectedDates([]);
      alert("Request submitted! Awaiting admin approval.");
    } catch (err) {
      alert("Error: " + err.message);
    } finally {
      setHistorySubmitting(false);
    }
  };

  const handleHistoryReset = async () => {
    if (!historyRequest?.requestId) return;
    setHistorySubmitting(true);
    try {
      const res = await fetch(VIEW_REQUEST_API, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ action: "delete", requestId: historyRequest.requestId }),
      });
      if (!res.ok) throw new Error("Reset failed");
      setHistoryRequest(null);
      setHistorySelectedDates([]);
    } catch (err) {
      alert("Error: " + err.message);
    } finally {
      setHistorySubmitting(false);
    }
  };

  // --- ROBUST COMMISSION EDIT ---
  const handleEditSave = async (tx) => {
    setActionLoading(true);
    try {
      const newComm = Number(editValues.commission || 0);

      // --- CHECK IF THIRD PARTY ---

      // 1. Always Update the Ledger (PATCH)
      await fetch(API_URL, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          paymentId: tx.paymentId,
          paymentType: tx.paymentType,
          commission: newComm,
          remarks: editValues.remarks,
          editingBranch: branchId,
        }),
      });

      // 2. Only Update Balance if NOT a Third Party Transaction

      // 3. Refresh UI
      setEditingId(null);
      fetchTransactions(branchId);
      fetchSummaryTransactions(branchId);
    } catch (err) {
      console.error(err);
      alert("Edit Failed");
    }
    setActionLoading(false);
  };
  const fetchSummaryTransactions = useCallback(
    async (myId) => {
      if (!myId || !auth.user?.access_token) return;
      setLoading(true);
      try {
        // 1. Calculate IST date string directly to avoid UTC/local timezone drift
        const IST_OFFSET = 5.5 * 60 * 60 * 1000;
        const targetDateStr = new Date(
          Date.now() - viewDay * 24 * 60 * 60 * 1000 + IST_OFFSET,
        )
          .toISOString()
          .split("T")[0];

        // console.log(
        //   `Fetching Summary for Branch: ${myId} on Target Date: ${targetDateStr}`,
        // );

        // 2. Set both start and end parameters to targetDateStr
        const baseUrl = `https://${process.env.REACT_APP_API_KEY_SUMMARY}.execute-api.ap-south-1.amazonaws.com/default/getAllBranchSummary`;
        const url = `${baseUrl}?start=${targetDateStr}&end=${targetDateStr}`;

        const res = await fetch(url, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${auth.user.access_token}`,
            "Content-Type": "application/json",
          },
        });

        if (!res.ok) {
          const errorData = await res.json();
          throw new Error(
            errorData.error || `HTTP error! status: ${res.status}`,
          );
        }

        const result = await res.json();

        // 3. Extract this specific branch's pre-computed map matrices
        const serverSummaryMap = result.summary || {};
        const myBranchMetrics = serverSummaryMap[myId] || {
          opBal: 0,
          totalIn: 0,
          btIn: 0,
          totalOut: 0,
          btOut: 0,
          comm: 0,
          exp: 0,
          closingBal: 0,
        };

        // 4. Update core layout states
        setBranchSummary(myBranchMetrics);
      } catch (err) {
        console.error(
          "Failed to sync data parameters via backend loop:",
          err.message,
        );
      } finally {
        setLoading(false);
      }
    },
    [auth.user?.access_token, viewDay],
  );
  useEffect(() => {
    if (branchId) fetchSummaryTransactions(branchId);
  }, [viewDay, branchId, fetchSummaryTransactions]);

  useEffect(() => {
    if (!branchId) return;
    Promise.all([
      fetchTransactions(branchId),
      fetchSummaryTransactions(branchId),
    ]);
  }, [branchId, fetchTransactions, fetchSummaryTransactions]);

  const updateStatus = async (tx, status) => {
    setActionLoading(true);
    try {
      const response = await fetch(PATCH_API_URL, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          paymentId: tx.paymentId,
          paymentType: tx.paymentType,
          status,
          linkedId: tx.linkedId || null,
          linkedPaymentType: tx.linkedPaymentType || null, // ← add this
        }),
      });

      if (!response.ok) {
        const errPayload = await response.json();
        throw new Error(errPayload.error || "Status update failed.");
      }

      // ✅ Update local state instantly — no refetch needed
      setTransactions((prev) =>
        prev.map((t) =>
          t.paymentId === tx.paymentId || t.paymentId === tx.linkedId
            ? { ...t, status }
            : t,
        ),
      );

      // 🔄 Refetch in background to sync summary (non-blocking)
      fetchSummaryTransactions(branchId);
      fetchTransactions(branchId);
    } catch (err) {
      console.error("Status update failed:", err);
      alert(`Status update failed: ${err.message}`);
    } finally {
      setActionLoading(false);
    }
  };

  // FIXED: handlePost now applies clean structural mapping to both ledger keys dynamically
  const handlePost = async (e) => {
    e.preventDefault();
    if (loading) return;
    if (
      (isToBranch && branchSearch && !allBranches.includes(branchSearch)) ||
      branchSearch === branchId
    ) {
      return alert("Please select a valid Target Branch.");
    }

    if (
      !isToBranch &&
      partySearch &&
      !party.some((p) => p.partyName === partySearch)
    ) {
      return alert("Please select a valid Third Party.");
    }

    setActionLoading(true);
    const fd = new FormData(e.target);
    const baseId = `TX-${Date.now()}`;
    const amount = parseFloat(fd.get("amount"));
    const commission = parseFloat(fd.get("commission")) || 0;
    const target = fd.get("targetBranch");
    const thirdParty = fd.get("thirdParty");
    const currentTimestamp = new Date().toISOString();

    let payload = [];
    if (selectedType === "EXP") {
      payload.push({
        paymentId: `${baseId}-EXP`,
        paymentType: "EXP",
        flowRole: "SENDER",
        fromBranch: branchId,
        toBranch: branchId,
        amount,
        commission: 0,
        status: "DELIVERED",
        remarks: fd.get("remarks"),
        timestamp: currentTimestamp,
      });
    } else if (target === "" && selectedType !== "COMM") {
      payload.push({
        paymentId: `${baseId}-IN-SELF`,
        paymentType: selectedType,
        flowRole: "SENDER",
        fromBranch: branchId,
        toBranch: branchId,
        amount,
        commission: 0,
        status: "DELIVERED",
        remarks: fd.get("remarks"),
        timestamp: currentTimestamp,
      });
    } else if (selectedType === "COMM") {
      const finalCommission = Number(fd.get("commission")) || 0;
      payload.push({
        paymentId: `${baseId}-IN-COMM`,
        paymentType: "IN",
        flowRole: "SENDER",
        fromBranch: branchId,
        toBranch: branchId,
        amount: 0,
        commission: finalCommission,
        status: "DELIVERED",
        remarks: fd.get("remarks"),
        timestamp: currentTimestamp,
      });
    } else if (!isToBranch && thirdParty !== "NONE") {
      const lakOppositeType =
        selectedType === "IN"
          ? "OUT"
          : selectedType === "OUT"
            ? "IN"
            : selectedType === "BTIN"
              ? "BTOUT"
              : "BTIN";
      payload.push({
        paymentId: `${baseId}-TP`,
        paymentType: selectedType,
        flowRole: "SENDER",
        fromBranch: branchId,
        toBranch: thirdParty,
        amount,
        commission,
        senderName: fd.get("sName"),
        senderCell: fd.get("sCell"),
        receiverName: fd.get("rName"),
        receiverCell: fd.get("rCell"),
        status: "DELIVERED",
        thirdParty: thirdParty,
        linkedId: `${baseId}-LAK`,
        remarks: `[TP: ${thirdParty}] ${fd.get("remarks")}`,
        timestamp: currentTimestamp,
      });
      payload.push({
        paymentId: `${baseId}-LAK`,
        paymentType: lakOppositeType,
        flowRole: "SENDER",
        fromBranch: "LAK",
        toBranch: branchId,
        amount,
        commission: 0,
        status: "DELIVERED",
        thirdParty: thirdParty,
        linkedId: `${baseId}-TP`,
        remarks: `[LAK-TP: ${thirdParty}] ${fd.get("remarks")}`,
        timestamp: currentTimestamp,
      });
    } else {
      const pType =
        selectedType === "IN"
          ? "OUT"
          : selectedType === "OUT"
            ? "IN"
            : selectedType === "BTIN"
              ? "BTOUT"
              : "BTIN";

      const senderItem = {
        paymentId: `${baseId}-${selectedType}`,
        paymentType: selectedType,
        flowRole: "SENDER",
        fromBranch: branchId,
        toBranch: target,
        amount,
        commission,
        senderName: fd.get("sName") || null,
        senderCell: fd.get("sCell") || null,
        receiverName: fd.get("rName"),
        receiverCell: fd.get("rCell"),
        status: "PENDING",
        remarks: fd.get("remarks"),
        timestamp: currentTimestamp,
        linkedId: `${baseId}-${pType}`,
      };

      const receiverItem = {
        ...senderItem,
        paymentId: senderItem.linkedId,
        paymentType: pType,
        flowRole: "RECEIVER",
        commission: 0, // Receiver branch handles their portion cleanly independently
        linkedId: senderItem.paymentId,
      };

      payload = [senderItem, receiverItem];
    }

    try {
      await fetch(API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ transactions: payload }),
      });
      e.target.reset();
      fetchTransactions(branchId);
      fetchSummaryTransactions(branchId);
    } catch (err) {
      alert("Post Failed");
    } finally {
      setActionLoading(false);
      setBranchSearch("");
      setPartySearch("");
      setViewDay(0);
    }
  };

  const handleMultiSplit = async () => {
    const totalAlloc =
      parseFloat(keepAmount || 0) +
      otherSplits.reduce((s, x) => s + parseFloat(x.amount || 0), 0);

    if (Math.abs(totalAlloc - splitTx.amount) > 0.01) {
      alert("Split error: Totals do not match original amount.");
      return;
    }

    setActionLoading(true);
    try {
      const originalType = splitTx.paymentType;
      const isBT = originalType.startsWith("BT");
      const isInflow = originalType.includes("IN");

      let nType = isBT
        ? isInflow
          ? "BTSPLITIN"
          : "BTSPLITOUT"
        : isInflow
          ? "SPLITIN"
          : "SPLITOUT";

      const nId = splitTx.paymentId.replace(
        /-(IN|OUT|BTIN|BTOUT)$/,
        `-${nType}`,
      );

      const payload = [
        {
          ...splitTx,
          paymentId: nId,
          paymentType: nType,
          amount: parseFloat(keepAmount),
          status: "DELIVERED",
          remarks: `Split Keep from ${splitTx.paymentId}. SPLITED to ${otherSplits.map((os) => os.branch).join(", ")}. Sender Remark: ${splitTx.remarks}`,
        },
      ];

      otherSplits.forEach((s, i) => {
        if (s.branch && s.amount > 0) {
          payload.push({
            ...splitTx,
            paymentId: `${nId}-PART-${i}`,
            paymentType: nType,
            receiverName: s.receiverName,
            receiverCell: s.receiverCell,
            toBranch: s.branch,
            amount: parseFloat(s.amount),
            commission: 0,
            remarks: `${s.remarks}, Split Part from ${splitTx.paymentId} via ${branchId}. Splits:${otherSplits.map((os) => `${os.branch}`).join(", ")}`,
            status: "PENDING",
            flowRole: "RECEIVER",
          });
        }
      });

      const delRes = await fetch(API_URL, {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          paymentId: splitTx.paymentId,
          paymentType: splitTx.paymentType,
        }),
      });

      if (!delRes.ok)
        throw new Error("Delete failed. Check Lambda permissions.");

      await fetch(API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ transactions: payload }),
      });

      if (splitTx.linkedId) {
        const originalType = splitTx.paymentType;
        let oppositeType;

        if (originalType.includes("BTSPLIT")) {
          oppositeType = originalType.includes("IN")
            ? "BTSPLITOUT"
            : "BTSPLITIN";
        } else if (originalType.includes("SPLIT")) {
          oppositeType = originalType.includes("IN") ? "SPLITOUT" : "SPLITIN";
        } else if (originalType.startsWith("BT")) {
          oppositeType = originalType.includes("IN") ? "BTOUT" : "BTIN";
        } else {
          oppositeType = originalType === "IN" ? "OUT" : "IN";
        }

        await fetch(API_URL, {
          method: "PATCH",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            paymentId: splitTx.linkedId,
            paymentType: oppositeType,
            status: "DELIVERED",
          }),
        });
      }

      await new Promise((r) => setTimeout(r, 600));
      alert("Split successful. Original 'fromBranch' preserved.");
      fetchTransactions(branchId);
      fetchSummaryTransactions(branchId);
    } catch (err) {
      alert("Error: " + err.message);
    } finally {
      setSplitTx(null);
      setActionLoading(false);
      setOtherSplits([
        {
          branch: "",
          amount: 0,
          remarks: "",
          receiverName: "",
          receiverCell: "",
        },
      ]);
    }
  };

  // const fetchWaitingTransactions = useCallback(async () => {
  //   if (!branchId) return;
  //   setLoading(true);
  //   try {
  //     const res = await fetch(API_URL);
  //     const data = await res.json();

  //     // 1. Get the Array
  //     const pendingArray = (data.transactions || []).filter(
  //       (tx) =>
  //         tx.status === "WAITING" &&
  //         tx.flowRole === "RECEIVER" &&
  //         tx.toBranch === branchId,
  //     );

  //     // 2. Calculate the Sum
  //     const totalSum = pendingArray.reduce(
  //       (sum, tx) => sum + Number(tx.amount || 0),
  //       0,
  //     );

  //     // 3. Save the SUM (a Number) to state
  //     setWaitingTransactions(totalSum);
  //   } catch (err) {
  //     console.error("Fetch Error:", err);
  //     setWaitingTransactions(0);
  //   } finally {
  //     setLoading(false);
  //   }
  // }, [branchId]);
  // useEffect(() => {
  //   fetchWaitingTransactions();
  // }, [fetchWaitingTransactions]);

  // const summary = useMemo(() => {
  //   const stats = transactions.reduce(
  //     (acc, tx) => {
  //       if (tx.status === "REJECTED") return acc;
  //       if (tx.status === "PENDING" && tx.flowRole === "RECEIVER") return acc;
  //       if (tx.status === "WAITING" && tx.flowRole === "RECEIVER") return acc;

  //       const isToday = checkDate(tx.timestamp, viewDay);
  //       setSummaryStart(
  //         new Date(Date.now() - viewDay * 24 * 60 * 60 * 1000)
  //           .toISOString()
  //           .split("T")[0],
  //       );
  //       setSummaryEnd(
  //         new Date(Date.now() - viewDay * 24 * 60 * 60 * 1000)
  //           .toISOString()
  //           .split("T")[0],
  //       );
  //       const amt = Number(tx.amount || 0);
  //       const comm = Number(tx.commission || 0);
  //       const isThirdParty = tx.thirdParty && tx.thirdParty !== "NONE";

  //       const isRealCash =
  //         tx.flowRole === "SENDER" ||
  //         (tx.flowRole === "RECEIVER" &&
  //           (tx.status === "APPROVED" || tx.status === "DELIVERED"));

  //       if (isToday) {
  //         // --- 1. INFLOW LOGIC (Cash vs BT) ---
  //         if (["IN", "BTIN", "SPLITIN", "BTSPLITIN"].includes(tx.paymentType)) {
  //           // Updated condition: Group BTIN and BTSPLITIN together
  //           if (["BTIN", "BTSPLITIN"].includes(tx.paymentType)) {
  //             acc.todayBTIn += amt;
  //           } else {
  //             acc.todayIn += amt; // Standard IN / SPLITIN
  //           }

  //           if (isRealCash) acc.netToday += amt;
  //         }

  //         // --- 2. OUTFLOW LOGIC (Cash vs BT vs EXP) ---
  //         else if (
  //           ["OUT", "BTOUT", "SPLITOUT", "EXP", "BTSPLITOUT"].includes(
  //             tx.paymentType,
  //           )
  //         ) {
  //           // Updated condition: Group BTOUT and BTSPLITOUT together
  //           if (["BTOUT", "BTSPLITOUT"].includes(tx.paymentType)) {
  //             acc.todayBTOut += amt;
  //           } else if (tx.paymentType === "EXP") {
  //             acc.todayExp += amt;
  //           } else {
  //             acc.todayOut += amt; // Standard OUT / SPLITOUT
  //           }

  //           if (isRealCash) acc.netToday -= amt;
  //         }

  //         // --- 3. COMMISSION LOGIC ---
  //         if (comm > 0 && !isThirdParty) {
  //           acc.todayComm += comm;
  //           if (isRealCash) acc.netToday += comm;
  //         }
  //       }

  //       return acc;
  //     },
  //     {
  //       todayIn: 0,
  //       todayOut: 0,
  //       todayComm: 0,
  //       netToday: 0,
  //       todayBTIn: 0,
  //       todayBTOut: 0,
  //       todayExp: 0,
  //     },
  //   );

  //   return {
  //     ...stats,
  //     openingBalance:
  //       liveBalance - stats.netToday - (viewDay === 0 ? 0 : Tsummary.netToday), // Adjust opening balance based on viewDay
  //   };
  // }, [transactions, checkDate, liveBalance, viewDay, Tsummary.netToday]);
  const displayData = useMemo(() => {
    return transactions
      .filter(
        (tx) =>
          checkDate(tx.timestamp, viewDay) &&
          (tx.fromBranch + tx.toBranch)
            .toLowerCase()
            .includes(branchFilter.toLowerCase()) &&
          (typeFilter === "ALL" || tx.paymentType === typeFilter),
      )
      .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
  }, [transactions, branchFilter, typeFilter, viewDay, checkDate]);

  // const fetchWaitingTransactionsIN = useCallback(async () => {
  //   if (!branchId) return;
  //   setLoading(true);
  //   try {
  //     const res = await fetch(API_URL);
  //     const data = await res.json();

  //     // 1. Get the Array
  //     const pendingArray = (data.transactions || []).filter(
  //       (tx) =>
  //         tx.status === "WAITING" &&
  //         tx.flowRole === "RECEIVER" &&
  //         tx.toBranch === branchId &&
  //         ["IN", "BTIN", "SPLITIN"].includes(tx.paymentType),
  //     );

  //     // 2. Calculate the Sum
  //     const totalSum = pendingArray.reduce(
  //       (sum, tx) => sum + Number(tx.amount || 0),
  //       0,
  //     );

  //     // 3. Save the SUM (a Number) to state
  //     setWaitingTransactionsIN(totalSum);
  //   } catch (err) {
  //     console.error("Fetch Error:", err);
  //     setWaitingTransactionsIN(0);
  //   } finally {
  //     setLoading(false);
  //   }
  // }, [branchId]);
  // useEffect(() => {
  //   fetchWaitingTransactionsIN();
  // }, [fetchWaitingTransactionsIN]);

  // const fetchWaitingTransactionsOUT = useCallback(async () => {
  //   if (!branchId) return;
  //   setLoading(true);
  //   try {
  //     const res = await fetch(API_URL);
  //     const data = await res.json();

  //     // 1. Get the Array
  //     const pendingArray = (data.transactions || []).filter(
  //       (tx) =>
  //         tx.status === "WAITING" &&
  //         tx.flowRole === "RECEIVER" &&
  //         tx.toBranch === branchId &&
  //         ["OUT", "BTOUT", "SPLITOUT"].includes(tx.paymentType),
  //     );

  //     // 2. Calculate the Sum
  //     const totalSum = pendingArray.reduce(
  //       (sum, tx) => sum + Number(tx.amount || 0),
  //       0,
  //     );

  //     // 3. Save the SUM (a Number) to state
  //     setWaitingTransactionsOUT(totalSum);
  //   } catch (err) {
  //     console.error("Fetch Error:", err);
  //     setWaitingTransactionsOUT(0);
  //   } finally {
  //     setLoading(false);
  //   }
  // }, [branchId]);
  // useEffect(() => {
  //   fetchWaitingTransactionsOUT();
  // }, [fetchWaitingTransactionsOUT]);
  const isAnyLoading = loading || actionLoading;
  return (
    <>
      {isAnyLoading && (
        <>
          <div className="branch-click-guard" />
          <div className="branch-top-loader">
            <div className="branch-top-loader-bar">
              <span className="branch-top-loader-glow" />
            </div>
            <div className="branch-top-loader-dots">
              <span /><span /><span />
            </div>
          </div>
        </>
      )}
    <div className="branch-home">
      <Helmet>
        <title>Branch Home</title>
      </Helmet>
      <header className="branch-header-bar">
        <div className="header-brand">
          <div className="header-logo">V</div>
          <div className="header-title-group">
            <span className="header-app-name">VCAP</span>
            <span className="header-branch-badge">{branchId}</span>
          </div>
          <div className="header-day-toggle">
            <button
              className={`day-toggle-btn ${viewDay === 1 ? "active" : ""}`}
              onClick={() => setViewDay(1)}
            >
              Yesterday
            </button>
            <button
              className={`day-toggle-btn ${viewDay === 0 ? "active" : ""}`}
              onClick={() => setViewDay(0)}
            >
              Today
            </button>
          </div>
        </div>
        <div className="header-actions Branch-navigation">
          <div className="header-day-toggle">
            <button
              className={`day-toggle-btn ${viewDay === 1 ? "active" : ""}`}
              onClick={() => setViewDay(1)}
            >
              Yesterday
            </button>
            <button
              className={`day-toggle-btn ${viewDay === 0 ? "active" : ""}`}
              onClick={() => setViewDay(0)}
            >
              Today
            </button>
          </div>
          <button
            onClick={() => setSelectedBranch(branchId)}
            className="br-btn br-btn-outline"
          >
            Details
          </button>
          <button
            onClick={async () => {
              setLoading(true);
              await Promise.all([
                fetchTransactions(branchId),
                fetchSummaryTransactions(branchId),
              ]);
              setLoading(false);
            }}
            className="br-btn br-btn-refresh"
            disabled={loading}
          >
            <FaSyncAlt className={loading ? "spin" : ""} />
            {loading ? "Refreshing..." : "Refresh"}
          </button>
          <button
            onClick={() => {
              fetchHistoryRequest(branchId);
              setShowHistoryModal(true);
            }}
            className="br-btn br-btn-outline"
            title="View past transactions"
          >
            <FaHistory style={{ marginRight: 4 }} />
            History
            {historyRequest?.status === "PENDING" && <span className="history-pending-badge">Pending</span>}
            {historyRequest?.status === "APPROVED" && (historyRequest.grantedDates || []).length > 0 && <span className="history-approved-badge">View</span>}
          </button>
          <InstallPWA />
          <Link to="/training-video">
            <button className="br-btn br-btn-outline">Demo</button>
          </Link>
          <button onClick={handleSignOut} className="br-btn br-btn-signout">
            Sign Out
          </button>
        </div>
      </header>
      {/* History Ledger View */}
      {showHistoryLedger && historyRequest?.status === "APPROVED" && (historyRequest.grantedDates || []).length > 0 && (
        <div className="modal" style={{ zIndex: 900 }}>
          <BranchHistoryLedger
            branchId={branchId}
            grantedDates={historyRequest.grantedDates}
            onClose={() => setShowHistoryLedger(false)}
          />
        </div>
      )}
      {selectedBranch && (
        <div className="modal">
          <BranchDetailLedger
            branchId={branchId}
            transactions={transactions}
            closingBalInfo={branchSummary.closingBal}
            opBalance={branchSummary.opBal}
            totalIn={branchSummary.totalIn}
            totalOut={branchSummary.totalOut}
            btIn={branchSummary.btIn}
            btOut={branchSummary.btOut}
            exp={branchSummary.exp}
            comm={branchSummary.comm}
            summaryStart={currentFormattedDate}
            summaryEnd={currentFormattedDate}
            onClose={() => setSelectedBranch(null)}
          />
        </div>
      )}
      <div className="branch-summary-scroll">
      <div className="summary-visibility-bar">
        <button
          className="summary-eye-btn"
          onClick={() => setValuesHidden(v => !v)}
          title={valuesHidden ? "Show values" : "Hide values"}
        >
          {valuesHidden ? <FaEye /> : <FaEyeSlash />}
        </button>
      </div>
      <section className="branch-summary-grid">
        <div className="branch-summary-card card-opening">
          <div className="card-icon-wrap card-icon-opening"><FaHistory /></div>
          <div className="card-body">
            <p className="card-label">Opening Balance</p>
            <h3 className="card-value"><span className="card-currency">₹</span>{valuesHidden ? "••••" : (branchSummary.opBal?.toLocaleString("en-IN") ?? "—")}</h3>
          </div>
        </div>
        <div className="branch-summary-card card-in">
          <div className="card-icon-wrap card-icon-in"><FaArrowDown /></div>
          <div className="card-body">
            <p className="card-label">Cash IN</p>
            <h3 className="card-value"><span className="card-currency">₹</span>{valuesHidden ? "••••" : (branchSummary.totalIn?.toLocaleString("en-IN") ?? "—")}</h3>
          </div>
        </div>
        <div className="branch-summary-card card-bt-in">
          <div className="card-icon-wrap card-icon-bt"><FaArrowDown /></div>
          <div className="card-body">
            <p className="card-label">BT IN</p>
            <h3 className="card-value"><span className="card-currency">₹</span>{valuesHidden ? "••••" : (branchSummary.btIn?.toLocaleString("en-IN") ?? "—")}</h3>
          </div>
        </div>
        <div className="branch-summary-card card-out">
          <div className="card-icon-wrap card-icon-out"><FaArrowUp /></div>
          <div className="card-body">
            <p className="card-label">Cash OUT</p>
            <h3 className="card-value"><span className="card-currency">₹</span>{valuesHidden ? "••••" : (branchSummary.totalOut?.toLocaleString("en-IN") ?? "—")}</h3>
          </div>
        </div>
        <div className="branch-summary-card card-bt-out">
          <div className="card-icon-wrap card-icon-bt"><FaArrowUp /></div>
          <div className="card-body">
            <p className="card-label">BT OUT</p>
            <h3 className="card-value"><span className="card-currency">₹</span>{valuesHidden ? "••••" : (branchSummary.btOut?.toLocaleString("en-IN") ?? "—")}</h3>
          </div>
        </div>
        <div className="branch-summary-card card-exp">
          <div className="card-icon-wrap card-icon-exp"><FaEdit /></div>
          <div className="card-body">
            <p className="card-label">Expense</p>
            <h3 className="card-value"><span className="card-currency">₹</span>{valuesHidden ? "••••" : (branchSummary.exp?.toLocaleString("en-IN") ?? "—")}</h3>
          </div>
        </div>
        <div className="branch-summary-card card-comm">
          <div className="card-icon-wrap card-icon-comm"><FaPercentage /></div>
          <div className="card-body">
            <p className="card-label">Comm.</p>
            <h3 className="card-value"><span className="card-currency">₹</span>{valuesHidden ? "••••" : (branchSummary.comm?.toLocaleString("en-IN") ?? "—")}</h3>
          </div>
        </div>
        <div className="branch-summary-card card-closing">
          <div className="card-icon-wrap card-icon-closing"><FaCalculator /></div>
          <div className="card-body">
            <p className="card-label">Closing Balance</p>
            <h3 className="card-value card-value-closing"><span className="card-currency">₹</span>{valuesHidden ? "••••" : (branchSummary.closingBal?.toLocaleString("en-IN") ?? "—")}</h3>
          </div>
        </div>
      </section>
      </div>

      <section className="branch-section form-section">
        <div className="form-section-header">
          <div className="form-section-title">
            <FaPlus className="form-section-icon" />
            <h3>New Transaction</h3>
          </div>
          <div className="form-target-toggle">
            <button type="button" onClick={() => setIsToBranch(true)} className={`target-toggle-btn ${isToBranch ? "active" : ""}`}>
              To Branch
            </button>
            <button type="button" onClick={() => setIsToBranch(false)} className={`target-toggle-btn ${!isToBranch ? "active" : ""}`}>
              To 3rd Party
            </button>
          </div>
        </div>

        <div className="tx-type-pills">
          {[
            { value: "IN",    label: "IN",      color: "pill-in" },
            { value: "OUT",   label: "OUT",     color: "pill-out" },
            { value: "BTIN",  label: "BT IN",   color: "pill-btin" },
            { value: "BTOUT", label: "BT OUT",  color: "pill-btout" },
            { value: "EXP",   label: "EXPENSE", color: "pill-exp" },
            { value: "COMM",  label: "COMM",    color: "pill-comm" },
          ].map(({ value, label, color }) => (
            <button
              key={value}
              type="button"
              onClick={() => setSelectedType(value)}
              className={`tx-type-pill ${color} ${selectedType === value ? "selected" : ""}`}
            >
              {label}
            </button>
          ))}
        </div>

        <form onSubmit={handlePost} className="branch-form-grid">
          <div className="branch-form-row">
            {/* CONDITIONAL RENDERING BASED ON BUTTON TOGGLE */}
            {isToBranch ? (
              <div
                className="searchable-branch-container"
                style={{ position: "relative" }}
              >
                {/* Search Input */}
                <input
                  type="text"
                  placeholder="Type Branch Name..."
                  value={branchSearch}
                  onChange={(e) =>
                    setBranchSearch(e.target.value.toUpperCase())
                  }
                  onBlur={() => {
                    // Small timeout to allow the onClick of the suggestion to fire first
                    setTimeout(() => {
                      if (branchSearch && !allBranches.includes(branchSearch)) {
                        setBranchSearch(""); // Clear if it's not in the list
                        alert("Please select a valid branch from the list.");
                      }
                    }, 200);
                  }}
                  disabled={selectedType === "EXP" || selectedType === "COMM"}
                  className="branch-search-input"
                  autoComplete="off"
                />

                {/* Hidden Input to maintain your handlePost FormData logic */}
                <input type="hidden" name="targetBranch" value={branchSearch} />

                {/* Filtered Suggestions List */}
                {branchSearch && !allBranches.includes(branchSearch) && (
                  <div className="branch-suggestions">
                    {allBranches
                      .filter(
                        (b) =>
                          b
                            .toLowerCase()
                            .includes(branchSearch.toLowerCase()) &&
                          b !== branchId,
                      )
                      .slice(0, 5) // Limit to top 5 for mobile speed
                      .map((b) => (
                        <div
                          key={b}
                          className="suggestion-item"
                          onMouseDown={(e) => {
                            e.preventDefault(); // Prevents the input from blurring before the selection
                            setBranchSearch(b);
                          }}
                        >
                          {b}
                        </div>
                      ))}
                  </div>
                )}
              </div>
            ) : (
              <div
                className="searchable-branch-container"
                style={{ position: "relative" }}
              >
                {/* Search Input for Third Party */}
                <input
                  type="text"
                  placeholder="Type 3rd Party Name..."
                  value={partySearch}
                  onChange={(e) => setPartySearch(e.target.value.toUpperCase())}
                  onBlur={() => {
                    setTimeout(() => {
                      const isValid = party.some(
                        (p) => p.partyName === partySearch,
                      );
                      if (partySearch && !isValid) {
                        setPartySearch("");
                        alert(
                          "Invalid Third Party. Please select from the suggestions.",
                        );
                      }
                    }, 200);
                  }}
                  className="branch-search-input"
                  autoComplete="off"
                  required={!isToBranch}
                />

                {/* Hidden Input to store the actual ID for handlePost */}
                <input
                  type="hidden"
                  name="thirdParty"
                  value={
                    party.find((p) => p.partyName === partySearch)?.id || ""
                  }
                />

                {/* Filtered Suggestions List */}
                {partySearch &&
                  !party.some((p) => p.partyName === partySearch) && (
                    <div className="branch-suggestions">
                      {party
                        .filter((p) =>
                          p.partyName
                            .toLowerCase()
                            .includes(partySearch.toLowerCase()),
                        )
                        .slice(0, 5)
                        .map((p) => (
                          <div
                            key={p.id}
                            className="suggestion-item"
                            onMouseDown={(e) => {
                              e.preventDefault();
                              setPartySearch(p.partyName.toUpperCase());
                            }}
                          >
                            {p.partyName}
                          </div>
                        ))}
                    </div>
                  )}
              </div>
            )}
          </div>
          <div className="branch-party-grid">
            <div className="form-field">
              <label className="form-label">Party Name</label>
              <input
                name="rName"
                placeholder="Enter party name"
                className="form-input"
                required
                disabled={
                  selectedType === "EXP" || selectedType === "COMM" ||
                  !isToBranch || selectedType === "BTIN" || selectedType === "BTOUT"
                }
              />
            </div>
            <div className="form-field">
              <label className="form-label">Mobile Number</label>
              <input
                name="rCell"
                placeholder="Enter mobile number"
                className="form-input"
                required
                disabled={
                  selectedType === "EXP" || selectedType === "COMM" ||
                  !isToBranch || selectedType === "BTIN" || selectedType === "BTOUT"
                }
              />
            </div>
          </div>
          <div className="branch-form-row">
            <div className="form-field">
              <label className="form-label">Amount (₹)</label>
              <input
                name="amount"
                type="number"
                placeholder="0.00"
                className="form-input"
                required
                disabled={selectedType === "COMM"}
              />
            </div>
            <div className="form-field">
              <label className="form-label">Commission (₹)</label>
              <input
                name="commission"
                type="number"
                placeholder="0.00"
                className="form-input"
                disabled={
                  selectedType === "EXP" || selectedType === "BTOUT" ||
                  selectedType === "BTIN"
                }
              />
            </div>
            <div className="form-field">
              <label className="form-label">Remarks</label>
              <input name="remarks" placeholder="Add a note..." className="form-input" required />
            </div>
          </div>
          <button type="submit" className="post-btn" disabled={actionLoading}>
            {actionLoading ? (
              <><FaSyncAlt className="spin" /> Processing...</>
            ) : (
              <><FaPlus /> Post Transaction</>
            )}
          </button>
        </form>
      </section>

      <section className="branch-section">
        <div className="ledger-header">
          <h3>Ledger</h3>
          <div className="filter-group">
            <FaSearch />
            <input
              placeholder="Filter..."
              onChange={(e) => setBranchFilter(e.target.value)}
            />
            <select
              value={typeFilter}
              onChange={(e) => setTypeFilter(e.target.value)}
            >
              <option value="ALL">All Types</option>
              <option value="IN">IN</option>
              <option value="OUT">OUT</option>
              <option value="SPLITIN">SPLITIN</option>
              <option value="SPLITOUT">SPLITOUT</option>
              <option value="BTIN">BTIN</option>
              <option value="BTOUT">BTOUT</option>
              <option value="BTSPLITIN">BTSPLITIN</option>
              <option value="BTSPLITOUT">BTSPLITOUT</option>
              <option value="EXP">EXPENSE</option>
            </select>
          </div>
        </div>

        {splitTx && (
          <div className="split-overlay-active">
            <div className="split-card-modal">
              <h3>Split (₹{splitTx.amount})</h3>
              <div className="split-row">
                <span>Keep Amount:</span>
                <input
                  type="number"
                  value={keepAmount}
                  onChange={(e) => setKeepAmount(e.target.value)}
                />
              </div>
              <p>Split To:</p>
              {otherSplits.map((s, i) => (
                <div key={i} className="split-row">
                  <select
                    value={s.branch}
                    onChange={(e) => {
                      const u = [...otherSplits];
                      u[i].branch = e.target.value;
                      setOtherSplits(u);
                    }}
                  >
                    <option value="">Branch</option>
                    {allBranches
                      .filter((b) => b !== branchId)
                      .map((b) => (
                        <option key={b} value={b}>
                          {b}
                        </option>
                      ))}
                  </select>
                  <input
                    type="number"
                    value={s.amount}
                    onChange={(e) => {
                      const u = [...otherSplits];
                      u[i].amount = e.target.value;
                      setOtherSplits(u);
                    }}
                    placeholder="Amount"
                  />

                  <input
                    type="text"
                    value={s.receiverName} // Use s.receiverName
                    onChange={(e) => {
                      const u = [...otherSplits];
                      u[i].receiverName = e.target.value;
                      setOtherSplits(u);
                    }}
                    placeholder="Party Name"
                    required
                  />
                  <input
                    type="text"
                    value={s.receiverCell} // Use s.receiverCell
                    onChange={(e) => {
                      const u = [...otherSplits];
                      u[i].receiverCell = e.target.value;
                      setOtherSplits(u);
                    }}
                    placeholder="Party Cell No"
                    required
                  />
                  <input
                    type="text"
                    value={s.remarks} // Use s.remarks
                    onChange={(e) => {
                      const u = [...otherSplits];
                      u[i].remarks = e.target.value;
                      setOtherSplits(u);
                    }}
                    placeholder="Remarks..."
                    required
                  />
                  <FaTrash
                    onClick={() =>
                      setOtherSplits(otherSplits.filter((_, idx) => idx !== i))
                    }
                  />
                </div>
              ))}
              <button
                type="button"
                onClick={() =>
                  setOtherSplits([...otherSplits, { branch: "", amount: 0 }])
                }
                className="S1"
              >
                <FaPlus /> Add
              </button>
              <div className="modal-actions">
                {!actionLoading ? (
                  <>
                    <button onClick={handleMultiSplit} className="S2">
                      Confirm
                    </button>
                  </>
                ) : (
                  <button disabled className="S2">
                    Splitting <FaSyncAlt className="spin" />
                  </button>
                )}
                <button
                  onClick={() => {
                    setSplitTx(null);
                    setOtherSplits([
                      {
                        branch: "",
                        amount: 0,
                        remarks: "",
                        receiverName: "",
                        receiverCell: "",
                      },
                    ]);
                  }}
                  className="S3"
                >
                  X-Cancel
                </button>
              </div>
            </div>
          </div>
        )}
        <div className="table-Container">
          <table className="branch-table">
            <thead>
              <tr>
                <th>TYPE</th>
                <th>FROM</th>
                <th>TO</th>
                <th>PARTIES</th>
                <th>AMOUNT</th>
                <th>COMM</th>
                <th>STATUS</th>
                <th>ACTIONS</th>
                <th>DATE</th>
                <th>REMARKS</th>
                <th>ID</th>
              </tr>
            </thead>
            <tbody>
              {displayData.map((tx) => (
                  <tr
                    key={tx.paymentId}
                    className={
                      tx.paymentType.includes("BT")
                        ? "TX-Color-Blue"
                        : tx.paymentType.includes("OUT") ||
                            tx.paymentType.includes("EXP")
                          ? "TX-Color-Red"
                          : "TX-Color-Green"
                    }
                  >
                    <td className={tx.paymentType}>{tx.paymentType}</td>
                    <td>{tx.fromBranch}</td>
                    <td>{tx.toBranch}</td>
                    <td>
                      <small>
                        {tx.receiverName} →{" "}
                        <a href={`tel:${tx.receiverCell}`}>
                          Call-
                          <PiPhoneCallFill />
                        </a>
                        <a href={`https://wa.me/${tx.receiverCell}`}>
                          <BiSolidMessageDetail />
                        </a>
                      </small>
                    </td>
                    <td>₹{tx.amount.toLocaleString("en-IN")}</td>
                    <td>
                      {editingId === tx.paymentId ? (
                        <input
                          type="number"
                          value={editValues.commission}
                          onChange={(e) =>
                            setEditValues({ ...editValues, commission: e.target.value })
                          }
                        />
                      ) : (
                        `₹${(tx.commission || 0).toLocaleString("en-IN")}`
                      )}
                    </td>
                    <td>
                      <span className={`status-pill ${tx.status?.toLowerCase()}`}>
                        {tx.status === "DELIVERED" && tx.paymentType.includes("IN") ? "RECEIVED" : tx.status}
                      </span>
                    </td>
                    <td className="br-actions">
                      <>
                        {editingId === tx.paymentId ? (
                          <FaSave onClick={() => handleEditSave(tx)} />
                        ) : (
                          <FaEdit onClick={() => { setEditingId(tx.paymentId); setEditValues({ commission: tx.commission, remarks: tx.remarks }); }} />
                        )}
                      </>
                      {tx.flowRole === "SENDER" && tx.status === "PENDING" && tx.toBranch === "" && (
                        <button onClick={() => updateStatus(tx, "DELIVERED")} className="primary-btn">Self Approve</button>
                      )}
                      {tx.flowRole === "RECEIVER" && tx.status === "PENDING" && (
                        <>
                          <button onClick={() => updateStatus(tx, "APPROVED")} className="primary-btn">Approve</button>
                          {!tx.paymentType.includes("SPLIT") && (
                            <button onClick={() => updateStatus(tx, "REJECTED")} className="secondary-btn">Reject</button>
                          )}
                        </>
                      )}
                      {(tx.status === "APPROVED" || tx.status === "WAITING") && tx.flowRole === "RECEIVER" && (
                        <>
                          <button onClick={() => updateStatus(tx, "DELIVERED")} className="primary-btn">Complete</button>
                          <button onClick={() => { setSplitTx(tx); setKeepAmount(tx.amount); }} className="secondary-btn">Split</button>
                        </>
                      )}
                      {tx.status === "APPROVED" && tx.flowRole === "RECEIVER" && (
                        <button onClick={() => updateStatus(tx, "WAITING")} className="secondary-btn">WAITING</button>
                      )}
                    </td>
                    <td>
                      <span>{new Date(tx.timestamp).toLocaleDateString("en-IN", { day: "2-digit", month: "2-digit", year: "numeric" })}</span>
                      <br />
                      <span>{new Date(tx.timestamp).toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" })}</span>
                    </td>
                    <td>
                      {editingId === tx.paymentId ? (
                        <input value={editValues.remarks} onChange={(e) => setEditValues({ ...editValues, remarks: e.target.value })} />
                      ) : (
                        tx.remarks
                      )}
                    </td>
                    <td>{tx.paymentId}</td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </section>
      <BranchRejected auth={auth} branchId={branchId} />
      <Message />

      {/* History Request Modal */}
      {showHistoryModal && (
        <div className="history-request-overlay" onClick={() => setShowHistoryModal(false)}>
          <div className="history-request-modal" onClick={(e) => e.stopPropagation()}>
            <h3>Past Transactions</h3>

            {/* STATUS BANNER */}
            {historyRequest?.status === "PENDING" && (
              <div className="history-status-banner pending">
                <span>⏳ Request Pending</span>
                <div style={{ fontSize: "0.78rem", marginTop: 4 }}>
                  Requested dates: <b>{(historyRequest.requestedDates || []).join(", ")}</b>
                </div>
                <div style={{ fontSize: "0.72rem", color: "#92400e", marginTop: 4 }}>
                  Waiting for admin approval. You can reset to submit a new request.
                </div>
              </div>
            )}

            {historyRequest?.status === "APPROVED" && (
              <div className="history-status-banner approved">
                <span>✅ Request Approved</span>
                <div style={{ fontSize: "0.78rem", marginTop: 4 }}>
                  Granted dates: <b>{(historyRequest.grantedDates || []).join(", ")}</b>
                </div>
              </div>
            )}

            {historyRequest?.status === "REJECTED" && (
              <div className="history-status-banner rejected">
                <span>❌ Request Rejected</span>
                <div style={{ fontSize: "0.72rem", marginTop: 4 }}>
                  Reset to submit a new request.
                </div>
              </div>
            )}

            {/* DATE SELECTION — only when no active request */}
            {!historyRequest && (
              <>
                <p style={{ fontSize: "0.8rem", color: "#64748b", marginBottom: 10 }}>
                  Select dates to request access. Admin will approve.
                </p>
                <div className="history-date-checkboxes">
                  {past7Days.map((day) => (
                    <div
                      key={day.value}
                      className={`history-date-check-row ${historySelectedDates.includes(day.value) ? "checked" : ""}`}
                      onClick={() => setHistorySelectedDates((prev) =>
                        prev.includes(day.value) ? prev.filter((d) => d !== day.value) : [...prev, day.value]
                      )}
                    >
                      <input type="checkbox" readOnly checked={historySelectedDates.includes(day.value)} />
                      <label>{day.label} ({day.value})</label>
                    </div>
                  ))}
                </div>
              </>
            )}

            <div className="history-modal-actions">
              <button className="history-cancel-btn" onClick={() => setShowHistoryModal(false)}>Close</button>

              {/* Reset — show when there is any existing request */}
              {historyRequest && (
                <button
                  className="history-reset-btn"
                  onClick={handleHistoryReset}
                  disabled={historySubmitting}
                >
                  {historySubmitting ? "…" : "🔄 Reset"}
                </button>
              )}

              {/* View Ledger — only when approved */}
              {historyRequest?.status === "APPROVED" && (historyRequest.grantedDates || []).length > 0 && (
                <button
                  className="history-submit-btn"
                  onClick={() => { setShowHistoryModal(false); setShowHistoryLedger(true); }}
                >
                  View Ledger
                </button>
              )}

              {/* Submit — only when no active request and dates selected */}
              {!historyRequest && (
                <button
                  className="history-submit-btn"
                  onClick={handleHistorySubmit}
                  disabled={historySubmitting || historySelectedDates.length === 0}
                >
                  {historySubmitting ? "Submitting…" : "Submit Request"}
                </button>
              )}
            </div>
          </div>
        </div>
      )}


    </div>
    </>
  );
}
